import { createSlice } from '@reduxjs/toolkit';
import { getParameterDirections } from 'ducks/parameter-directions-list/operators';
import { Slices } from 'ducks/slices';
import { normalizeLookups } from 'ducks/utils';

export type ParameterDirectionsListState = ReturnType<
  typeof normalizeLookups<'parameter_direction_name', 'parameter_direction_id'>
>;

const initialState: ParameterDirectionsListState = [];

const parameterDirectionsListSlice = createSlice({
  name: Slices.PARAMETER_DIRECTIONS_LIST,
  initialState,
  reducers: {
    clearParameterDirectionsList: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getParameterDirections.pending, () => {
        return initialState;
      })
      .addCase(getParameterDirections.fulfilled, (_, { payload }) => {
        return normalizeLookups(payload, 'parameter_direction_name', 'parameter_direction_id');
      })
      .addCase(getParameterDirections.rejected, () => {
        return initialState;
      });
  },
});

export const { clearParameterDirectionsList } = parameterDirectionsListSlice.actions;

export default parameterDirectionsListSlice.reducer;
